module.exports = {
      id: "app-gallery-usage",
      viewBox: "0 0 161 48",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#app-gallery",
      toString: function () {
        return this.url;
      }
    }